import slugify from "slugify";
import { TODO } from "@habity/types";

export const getOfficeSlug = (office: TODO) => {
  const { id, name } = office || {};
  if (!id || !name) return "";

  const nameText = slugify(name, { lower: true });

  return `${nameText}-${id}`;
};
